import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client.ts";
import type { ValidateReturnRequestLineItemsBodyDto } from "../generated/schema.ts";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request.ts";

interface UseValidateReturnRequestLineItemsParams {
	onSuccess?: () => void;
	onError?: () => void;
	onMutate?: () => void;
}

export default function useValidateReturnRequestLineItems(
	params?: UseValidateReturnRequestLineItemsParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateReturnRequest = useInvalidateReturnRequest();
	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/line-items/validate",
	);

	return useMutation({
		onMutate: params?.onMutate,
		onSuccess(_, variables) {
			successNotification();
			invalidateReturnRequest({
				shopId: variables.shopId,
				returnRequestId: variables.returnRequestId,
			});
			params?.onSuccess?.();
		},
		onError() {
			errorNotification();
			params?.onError?.();
		},
		mutationFn: async (variables: {
			shopId: string;
			returnRequestId: string;
			requestBody: ValidateReturnRequestLineItemsBodyDto;
		}) => {
			return mutation.mutateAsync({
				params: {
					path: {
						shopId: variables.shopId,
						returnRequestId: variables.returnRequestId,
					},
				},
				body: variables.requestBody,
			});
		},
	});
}
